<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-card class="elevation-12" align-center justify-center>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Mutton Bustin' Registration</v-toolbar-title>
        </v-toolbar>
        <v-img
          src="/static/img/logo.png"
          height="150"
          contain
        ></v-img>

        <div class="headline text-xs-center mb-4">{{ currentYear }} RENO RODEO BRANDING ROOM REQUEST FORM</div>
        <div v-if="saved">
          <div class="subheading mx-4">
            <p>Thank you for your request. Someone from the Branding Room will be getting back to you.
              Some days may not be available or already sold out, first come first serve basis.</p>
          </div>
        </div>
        <div v-else>
          <div class="subheading mx-4">
            <p>Please enter your request for entrance into the Branding Room.
              Some days may not be available or already sold out, first come first serve basis.</p>
          </div>

          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.bussiness"
                    label="Business Name (If Applies)"
                    ref="focusName"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.name"
                    label="Contact Name"
                    :rules="[v => !!v || 'Name is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address"
                    label="Address"
                    :rules="[v => !!v || 'Address is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md5>
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :rules="[v => !!v || 'City is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md2>
                      <v-text-field
                        v-model="editedItem.state"
                        label="ST"
                        mask="AA"
                        :rules="[v => !!v || 'State is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItem.zip"
                        label="Zipcode"
                        mask="#####"
                        :rules="[v => !!v || 'Zip is required']"
                        required
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.cellPhone"
                    label="Phone"
                    mask="(###) ###-####"
                    return-masked-value
                    prepend-icon="stay_current_portrait"
                    :rules="[v => !!v || 'Primary Phone is required']"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    prepend-icon="email"
                    label="Email"
                    type="email"
                    v-model="editedItem.email"
                    :rules="emailRules"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.tickets"
                    label="Number of tickets"
                    mask="###"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field
                    v-model="editedItem.perfs"
                    label="Number of Performances"
                    mask="###"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  Please select the Perfomances you would like to attend.
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf1"
                    label="06/20/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf2"
                    label="06/21/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf3"
                    label="06/22/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf4"
                    label="06/23/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf5"
                    label="06/24/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf6"
                    label="06/25/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf7"
                    label="06/26/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf8"
                    label="06/27/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf9"
                    label="06/28/2024"
                  ></v-checkbox>
                </v-flex>
                <v-flex xs12 md2>
                  <v-checkbox
                    v-model="editedItem.perf10"
                    label="06/29/2024"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-container>

            <v-alert :value="error" type="warning" transition="scale-transition">
              <span v-html="error"></span>
            </v-alert>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" @click="save">Submit Request</v-btn>
            </v-card-actions>
          </v-form>
        </div>
      </v-card>
    </v-flex>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import moment from 'moment'

export default {
  data () {
    return {
      valid: true,
      currentYear: 0,
      checkbox: false,
      saved: false,
      editedItem: {
        name: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        homePhone: '',
        cellPhone: '',
        email: '',
        age: '',
        weight: '',
        birthDate: '',
        other: '',
        parents: ''
      },
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      error: null,
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.getDate()
  },

  methods: {
    getDate () {
      let currentYear = moment().format('YYYY')
      let nextYear = moment()
        .add(1, 'years')
        .format('YYYY')
      let currentDate = moment().format('MM')

      if (currentDate >= 7) {
        this.currentYear = nextYear
      } else {
        this.currentYear = currentYear
      }
    },

    async save () {
      try {
        this.editedItem.year = this.currentYear

        if (this.editedItem.perf1 === true) {
          this.editedItem.perf1 = 'Yes'
        }

        if (this.editedItem.perf2 === true) {
          this.editedItem.perf2 = 'Yes'
        }

        if (this.editedItem.perf3 === true) {
          this.editedItem.perf3 = 'Yes'
        }

        if (this.editedItem.perf4 === true) {
          this.editedItem.perf4 = 'Yes'
        }

        if (this.editedItem.perf5 === true) {
          this.editedItem.perf5 = 'Yes'
        }

        if (this.editedItem.perf6 === true) {
          this.editedItem.perf6 = 'Yes'
        }

        if (this.editedItem.perf7 === true) {
          this.editedItem.perf7 = 'Yes'
        }

        if (this.editedItem.perf8 === true) {
          this.editedItem.perf8 = 'Yes'
        }

        if (this.editedItem.perf9 === true) {
          this.editedItem.perf9 = 'Yes'
        }

        if (this.editedItem.perf10 === true) {
          this.editedItem.perf10 = 'Yes'
        }

        if (this.$refs.form.validate()) {
          const response = await Api().post('extern_brandingroom', this.editedItem)
          console.log(response.data)

          this.saved = true
          this.snackbar.message = 'Congratulation, request has been submitted!'
          this.snackbar.color = 'success'
          this.snackbar.show = true
        } else {
          this.snackbar.message = 'You have some errors on the page!'
          this.snackbar.color = 'error'
          this.snackbar.show = true
        }
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/brandingRoom/ExternalForm.vue